import { render, staticRenderFns } from "./actor-photos.vue?vue&type=template&id=eb126d02&scoped=true&"
import script from "./actor-photos.vue?vue&type=script&lang=ts&"
export * from "./actor-photos.vue?vue&type=script&lang=ts&"
import style0 from "./actor-photos.vue?vue&type=style&index=0&id=eb126d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb126d02",
  null
  
)

export default component.exports